import { MultiComboBox, type ComboBoxOption, type MultiComboBoxProps } from '../../cdl/ComboBox/ComboBox';
import { useEnums } from '../hooks/useEnums';

export interface EnumMultiComboBoxProps
    extends Omit<MultiComboBoxProps<ComboBoxOption>, 'value' | 'onChange' | 'options'> {
    onChange: (options: string[]) => void;
    enumType: string;
    context?: string;
    value: string[];
}

export function EnumMultiComboBox({ enumType, context, onChange, value, ...rest }: EnumMultiComboBoxProps) {
    const { getEnumsForTypeAndContext, getHumanReadableValue } = useEnums();
    const options = Object.keys(getEnumsForTypeAndContext(enumType, context)).map((key: string) => ({
        label: getHumanReadableValue(enumType, key),
        value: key,
    }));
    const isSearchable = rest.isSearchable ?? options.length > 6;

    return <MultiComboBox {...rest} value={value} onChange={onChange} options={options} isSearchable={isSearchable} />;
}
